import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as d, openBlock as l, normalizeClass as r, createElementVNode as s } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const n = {
  name: "DtIconSomewhatDissatisfiedFilled",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], m = /* @__PURE__ */ s("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M.563 6a5.437 5.437 0 1 1 10.874 0A5.437 5.437 0 0 1 .563 6Zm3.5-1.5c0-.242.195-.438.437-.438h.005a.437.437 0 1 1 0 .875H4.5a.437.437 0 0 1-.438-.437Zm3 0c0-.242.195-.438.437-.438h.005a.437.437 0 1 1 0 .875H7.5a.437.437 0 0 1-.438-.437Zm-1.84 2.938c-.37 0-.73.121-1.025.346l-.082.064a.438.438 0 0 1-.532-.696l.083-.063a2.563 2.563 0 0 1 1.556-.527h1.508c.598 0 1.178.21 1.638.593l.01.009a.437.437 0 1 1-.559.672l-.01-.008a1.688 1.688 0 0 0-1.08-.39H5.225Z",
  fill: "currentColor"
}, null, -1), _ = [
  m
];
function f(e, h, i, u, p, a) {
  return l(), d("svg", {
    "aria-label": i.ariaLabel,
    class: r([a.iconSizeClass, "d-icon d-icon--somewhat-dissatisfied-filled"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Somewhat Dissatisfied Filled",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, _, 10, c);
}
const g = /* @__PURE__ */ o(n, [["render", f]]);
export {
  g as default
};
//# sourceMappingURL=somewhat-dissatisfied-filled.js.map
